import BlogLayoutThree from './BlogLayoutThree'
import Link from 'next/link'
import { cn } from '@/utils'
import type { PostMeta } from '@/lib/content'

const BlogsGrid = ({ classNames = "", title, blogs }: {
    classNames?: string,
    title?: string,
    blogs: PostMeta[]
}) => {
    return (
        <div className={cn(`sm:max-w-5xl sm:mx-auto ${title ? "px-2 sm:px-4 xl:px-0" : "px-0"} z-20 flex-center flex-col`, classNames)}>
            {
                title &&
                <div className="w-full flex justify-between">
                    <h2 className="font-bold capitalize text-2xl sm:text-3xl md:text-4xl">
                        {title}
                    </h2>
                    <Link
                        href="/categories/all"
                        className="inline-block font-medium text-accent underline underline-offset-2 text-base md:text-lg"
                    >
                        View All
                    </Link>
                </div>
            }
            <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 lg:gap-6 mt-4">
                {blogs.map((blog, index) => {
                    return (
                        <article key={index}>
                            <BlogLayoutThree blog={blog} />
                        </article>
                    )
                })}
            </div>
        </div>
    )
}

export default BlogsGrid